import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz21 = () => {
    return (
        <div>
               <NavLink to='/category/Puzzels/Puzzel22'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel20'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <h1 class="title">3 Ants and Triangle</h1>
   
    <div class="text">
        <p>There are 3 ants sitting on three corners of a triangle. All ants randomly pick a direction and start moving
            along edge of the triangle. What is the probability that any two ants collide?</p>
        <p>&nbsp;<br/>&nbsp;</p>
        <p><strong>Hint:</strong> Every ant has two choices (pick either of two edges going through the corner on which
            ant is initially sitting).</p>
        <p>&nbsp;<br/>&nbsp;</p>
        <div class="containers">
        <p><strong>Answer:</strong><br/>Collision doesn’t happen only in following two cases<br/>1) All ants move in
            counterclockwise direction.<br/>
       
        <p>2) All ants move in clockwise direction.<br/></p>
        <p>Since every ant has two choices (pick either of two edges going through the corner on which ant is initially
            sitting), there are total 2<sup>3</sup> possibilities.</p>
        <p>Out of 2<sup>3</sup> possibilities, only 2 don’t cause collision. So, the probability of collision is
            <strong>6/8</strong> and the probability of non-collision is <strong>2/8</strong>.</p>
        </p>
        </div>
      
    </div>
</article>
        </div>
    )
}

export default Puz21
